import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { withRouter } from 'react-router-dom'
import { withSnackbar } from 'notistack'
import moment from 'moment-timezone'
import _ from 'lodash'

import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'

import TimezonePicker from './TimezonePicker'

import ImageTools from '../../../helpers/resizeImage'

class AddLocation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      height: 0,
      imagePreviewUrl: props.imagePreviewUrl,
      imageBlob: null,
      updateLocation: props.updateLocation,
      updateLocationID: props.updateLocationID,
      modalTitle: props.modalTitle,
      location: props.locationData
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
  }
  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }

  dismiss = () => {
    const confirm = window.confirm(
      'Are you sure you want to close this? your changes will not be saved.'
    )
    if (confirm) {
      this.props.toggleOpen()
    }
  }

  handleChange = e => {
    console.log(e.target.id)
    let location = Object.assign({}, this.state.location)
    location[e.target.id] = e.target.value
    this.setState({
      location
    })
  }

  handleImageChange = e => {
    e.preventDefault()

    ImageTools.resize(
      e.target.files[0],
      {
        width: 1200,
        height: 800
      },
      (blob, success) => {
        console.log(blob, success)
        let reader = new FileReader()
        reader.onloadend = () => {
          this.setState({
            imageBlob: blob,
            imagePreviewUrl: reader.result
          })
        }
        reader.readAsDataURL(blob)
      }
    )
  }

  setImage = (name = this.state.updateLocationID) =>
    new Promise(resolve => {
      const storage = this.props.firebase
        .storage()
        .ref()
        .child(`location_images/${name}`)
      const upload = storage.put(this.state.imageBlob)
      upload.on(
        this.props.firebase.storage.TaskEvent.STATE_CHANGED,
        snapshot => {},
        err => {},
        () => {
          upload.snapshot.ref
            .getDownloadURL()
            .then(url => {
              console.log(url)
              return resolve(url)
            })
            .catch(err => {
              this.props.enqueueSnackbar(
                `There was an error creating the room, ${err.message}`,
                {
                  variant: 'error'
                }
              )
              console.log(err)
            })
        }
      )
    })

  createLocation = e => {
    e.preventDefault()

    var newLocation = Object.assign({}, this.state.location)
    if (this.state.updateLocation) {
      this.updateLocationDoc(newLocation)
    } else {
      newLocation.created_at = this.props.firebase.firestore.FieldValue.serverTimestamp()
      this.createLocationDoc(newLocation)
    }
  }

  createLocationDoc = async location => {
    var loc = Object.assign({}, location)
    const ref = this.props.firestore.collection('locations').doc()
    if (this.state.imageBlob) {
      const url = await this.setImage(ref.id)
      loc.image = url
    }
    if (!loc.my_check_id.length) {
      loc.my_check_id = ref.id
    }
    ref
      .set(loc)
      .then(doc => {
        console.log(doc)
        this.props.enqueueSnackbar('Successfully created new location', {
          variant: 'success'
        })
        this.props.toggleOpen()
        this.props.history.push(`/locations/${ref.id}`)
      })
      .catch(err => {
        this.props.enqueueSnackbar(
          `There was an error creating the location, ${err.message}`,
          {
            variant: 'error'
          }
        )
        console.log(err)
      })
  }

  updateLocationDoc = async location => {
    var loc = Object.assign({}, location)
    if (this.state.imageBlob) {
      const url = await this.setImage()
      loc.image = url
    }
    if (!loc.my_check_id.length) {
      loc.my_check_id = this.state.updateLocationID
    }
    this.props.firestore
      .collection('locations')
      .doc(this.state.updateLocationID)
      .set(loc, { merge: true })
      .then(() => {
        this.props.enqueueSnackbar('Successfully updated location', {
          variant: 'success'
        })
        this.props.toggleOpen()
      })
      .catch(err => {
        this.props.enqueueSnackbar(
          `There was an error updating the location, ${err.message}`,
          {
            variant: 'error'
          }
        )
        console.log(err)
      })
  }

  updateTimezone = timezone => {
    console.log(timezone)
    let location = Object.assign({}, this.state.location)
    location.timezone = timezone
    this.setState(
      {
        location
      },
      () => {
        console.log(this.state.location)
      }
    )
  }

  render() {
    return (
      <Dialog
        fullWidth
        maxWidth="sm"
        fullScreen={this.state.width <= 600 ? true : false}
        className="add-location-modal"
        aria-labelledby="Add a Location"
        aria-describedby="Add a new Co-Working space"
        open={this.props.open}
      >
        <MuiDialogTitle disableTypography className="booking-modal-title">
          <Typography variant="h5">{this.state.modalTitle}</Typography>
          <IconButton
            onClick={this.dismiss}
            className="close-button"
            aria-label="Close"
          >
            <Icon>close</Icon>
          </IconButton>
        </MuiDialogTitle>
        <DialogContent style={{ paddingTop: 5 }}>
          <form onSubmit={this.createLocation}>
            <Grid container spacing={24}>
              <Grid item xs={12} style={{ position: 'relative' }}>
                <input
                  required={this.state.updateLocation ? false : true}
                  onChange={e => this.handleImageChange(e)}
                  accept="image/*"
                  style={{
                    position: 'absolute',
                    zIndex: 0,
                    opaity: 0.1,
                    left: 20,
                    right: 20,
                    bottom: 20,
                    top: 20
                  }}
                  id="image"
                  name="image"
                  type="file"
                />
                <label htmlFor="image">
                  <Button
                    className="upload-button"
                    variant="contained"
                    component="span"
                    style={{
                      width: '100%',
                      height: '50vw',
                      maxHeight: 250,
                      justifyContent: 'flex-end',
                      alignItems: 'flex-end',
                      backgroundImage: `url(${this.state.imagePreviewUrl})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover'
                    }}
                  >
                    Upload Image
                  </Button>
                </label>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  onChange={this.handleChange}
                  value={this.state.location.name}
                  variant="outlined"
                  required
                  id="name"
                  name="name"
                  label="Location Name"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TimezonePicker
                  value={this.state.location.timezone}
                  updateValue={this.updateTimezone}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  onChange={this.handleChange}
                  value={this.state.location.address}
                  name="address"
                  variant="outlined"
                  required
                  id="address"
                  label="Address"
                  fullWidth
                />
              </Grid>
              <Grid item xs={8} sm={9} md={5}>
                <TextField
                  onChange={this.handleChange}
                  value={this.state.location.city}
                  name="city"
                  variant="outlined"
                  required
                  id="city"
                  label="City"
                  fullWidth
                />
              </Grid>
              <Grid item xs={4} sm={3} md={3}>
                <TextField
                  onChange={this.handleChange}
                  value={this.state.location.state}
                  name="state"
                  variant="outlined"
                  required
                  id="state"
                  label="State"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  onChange={this.handleChange}
                  value={this.state.location.zip}
                  name="zip"
                  variant="outlined"
                  required
                  id="zip"
                  label="Zip Code"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Tooltip title="When a client is notified in the directory, the person using the directory will see this message on the screen.">
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.location.custom_directory_message}
                    name="custom_directory_message"
                    variant="outlined"
                    id="custom_directory_message"
                    label="Custom Directory Message"
                    fullWidth
                    multiline
                    rows={2}
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Tooltip title="The ID that will connect the app to MyCheck. If no value is set it will be auto-generated.">
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.location.my_check_id}
                    name="my_check_id"
                    variant="outlined"
                    id="my_check_id"
                    label="MyCheck ID"
                    fullWidth
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Tooltip title="The Coworking floor that will appear on the directory.">
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.location.coworking_floor}
                    name="coworking_floor"
                    variant="outlined"
                    id="coworking_floor"
                    label="Coworking Floor"
                    fullWidth
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={12}>
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.location.yardi_id}
                    name="yardi_id"
                    variant="outlined"
                    id="yardi_id"
                    label="Yardi ID"
                    fullWidth
                    placeholder="1234"
                    helperText="The ID of the corresponding Property in YardiKube."
                  />
                </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'flex-end' }}
              >
                <Button type="submit" variant="contained" color="primary">
                  {this.state.updateLocation ? 'Update' : 'Create'} Location
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    )
  }
}

AddLocation.defaultProps = {
  imagePreviewUrl: null,
  updateLocation: false,
  updateLocationID: null,
  modalTitle: 'Create a Location',
  locationData: {
    image: null,
    name: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    number_of_clients: 0,
    active: false,
    community_manager: null,
    center_manager: null,
    timezone: _.filter(moment.tz.names(), str => str.includes('America'))[0],
    custom_directory_message: "Please proceed to the client's office office.",
    my_check_id: ''
  }
}

export default compose(
  withRouter,
  firestoreConnect(),
  connect(),
  withSnackbar
)(AddLocation)
